import React from 'react';
import { Field, ErrorMessage, useFormikContext } from 'formik';

export const StepFour = () => {
  const { values } = useFormikContext();
  return (
    <div className="w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md step4">
      {/* <h6 className="text-lg font-bold mb-6">Agreement and Intentions</h6> */}

      <div className="mb-6 form-radio2-main">
        <label htmlFor="settlement-agreement" className="block text-gray-700 font-medium mb-2">
          Do you have a settlement agreement document?
        </label>
        <div className="space-y-2">
          <div className="flex items-center form-radio2">
            <Field
              type="radio"
              id="haveSettlementAgreementYes"
              name="settlement-agreement"
              value="Yes"
              className="mr-2"
            />
            <label htmlFor="haveSettlementAgreementYes">Yes</label>
          </div>
          <div className="flex items-center form-radio2">
            <Field
              type="radio"
              id="haveSettlementAgreementNo"
              name="settlement-agreement"
              value="No"
              className="mr-2"
            />
            <label htmlFor="haveSettlementAgreementNo">No</label>
          </div>
          <div className="flex items-center form-radio2">
            <Field
              type="radio"
              id="haveSettlementAgreementNotSure"
              name="settlement-agreement"
              value="Not sure"
              className="mr-2"
            />
            <label htmlFor="haveSettlementAgreementNotSure">Not Sure</label>
          </div>
          <ErrorMessage name="settlement-agreement" component="div" className="required-text" />
        </div>
      </div>

      {values['still-employed'] === 'E' && (
        <div className="mb-6 form-radio2-main">
          <label className="block text-gray-700 font-medium mb-2">
            Do you want to leave your job?
          </label>
          <div className="space-y-2">
            <div className="flex items-center form-radio2">
              <Field
                type="radio"
                id="wantToLeaveJobYes"
                name="what-is-your-objective"
                value="Yes"
                className="mr-2"
              />
              <label htmlFor="wantToLeaveJobYes">Yes</label>
            </div>
            <div className="flex items-center form-radio2">
              <Field
                type="radio"
                id="wantToLeaveJobNo"
                name="what-is-your-objective"
                value="No"
                className="mr-2"
              />
              <label htmlFor="wantToLeaveJobNo">No</label>
            </div>
            <div className="flex items-center form-radio2">
              <Field
                type="radio"
                id="wantToLeaveJobMaybe"
                name="what-is-your-objective"
                value="Maybe"
                className="mr-2"
              />
              <label htmlFor="wantToLeaveJobMaybe">Maybe</label>
            </div>
            <ErrorMessage name="what-is-your-objective" component="div" className="required-text" />
          </div>
        </div>
      )}
    </div>
  );
};
